import { render } from "./Billing.vue?vue&type=template&id=691470b0"
import script from "./Billing.vue?vue&type=script&lang=ts"
export * from "./Billing.vue?vue&type=script&lang=ts"
script.render = render

export default script